/**
 * Showcase Collection List
 * Desktop: tab-based switching of background image and content panel.
 * Mobile: Swiper carousel for collection cards.
 */
class ShowcaseCollectionList extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.backgrounds = [];
    this.panels = [];
    this.swiper = null;
    this.mobileBreakpoint = 992;
  }

  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-showcase-tab]')];
    this.backgrounds = [...this.querySelectorAll('[data-showcase-bg]')];
    this.panels = [...this.querySelectorAll('[data-showcase-panel]')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.getAttribute('data-showcase-tab');
        this.activate(index);
      });
    });

    this.initMobileSwiper();
    this._resizeHandler = this.handleResize.bind(this);
    window.addEventListener('resize', this._resizeHandler);
  }

  disconnectedCallback() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
    this.destroySwiper();
  }

  handleResize() {
    if (window.innerWidth >= this.mobileBreakpoint) {
      this.destroySwiper();
    } else if (!this.swiper) {
      this.initMobileSwiper();
    }
  }

  initMobileSwiper() {
    if (this.swiper || window.innerWidth >= this.mobileBreakpoint) return;

    var swiperEl = this.querySelector('.showcase-cl__cards');
    if (!swiperEl) return;

    var self = this;
    this.waitForSwiper(function () {
      if (self.swiper) return;
      self.swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        speed: 400
      });
    });
  }

  waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') return callback();
    if (window.loadSwiper) {
      window.loadSwiper().then(callback);
      return;
    }
    var check = setInterval(function () {
      if (typeof Swiper !== 'undefined') {
        clearInterval(check);
        callback();
      }
    }, 100);
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  activate(index) {
    this.tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-showcase-tab') === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.backgrounds.forEach((bg) => {
      bg.classList.toggle('is-active', bg.getAttribute('data-showcase-bg') === index);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.getAttribute('data-showcase-panel') === index);
    });
  }
}

customElements.define('showcase-collection-list', ShowcaseCollectionList);
